<script>
	import Holdings from './Holdings.svelte';

	import { projectSettings } from '../../config';
	import { pageNumber } from '../../stores';

	export let pageIndex = null;

	let disabled = true;

	pageNumber.update((p) => pageIndex);

	document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>
	<h1>EML Payments Class Action Holdings Update</h1>

	<section style="margin-=bottom: 20px;">
		<Holdings {disabled}></Holdings>
	</section>
</section>
